import { Typography } from "@/components/common/Typography/Typography"
import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Sparkles } from "lucide-react"
import type { UpsellProduct } from "./resolveSidebarNav"

interface UpsellCardProps {
  product: UpsellProduct
  onOpenUpsell: () => void
}

export const UpsellCard = ({ product, onOpenUpsell }: UpsellCardProps) => {
  const { translate } = useTranslation()
  const titleKey =
    product === "mc" ? "SIDEBAR/UPSELL_TITLE" : "SIDEBAR/QUESTIONNAIRE_MODULE"
  const bodyKey =
    product === "mc" ? "SIDEBAR/UPSELL_BODY" : "SIDEBAR/QA_UPSELL_BODY"

  return (
    <div className="group mx-2 mb-2 rounded-lg border border-primary/30 bg-primary/5 p-3">
      <div className="flex items-center gap-2">
        <Sparkles className="h-3.5 w-3.5 text-primary" aria-hidden="true" />
        <Typography variant="textXS-bold">{translate(titleKey)}</Typography>
      </div>
      <div className="mb-2.5 mt-1.5 grid grid-rows-[0fr] transition-[grid-template-rows] duration-200 ease-out group-focus-within:grid-rows-[1fr] group-hover:grid-rows-[1fr] motion-reduce:transition-none">
        <div className="min-h-0 overflow-hidden">
          <Typography variant="textXS" className="text-muted-foreground">
            {translate(bodyKey)}
          </Typography>
        </div>
      </div>
      <Button size="sm" className="h-7 w-full" onClick={onOpenUpsell}>
        {translate("SIDEBAR/UPSELL_CTA")}
      </Button>
    </div>
  )
}
